import styled from "styled-components";
import * as React from "react";
import cn from "classnames";

import { themeValues } from "../../theme";
import { IconTypes } from "../../types";
import { LearnMore } from "../../LearnMore";
import { StyledLearnMore } from "../../LearnMore/LearnMore";

export const Page = styled.div``;
Page.displayName = "Page";

// TODO:
export function PageBody() {

}

export const PageHeader = styled.div`
  border-bottom: 1px solid ${themeValues.borderColor};
  display: flex;
  align-items: center;
  padding-bottom: 16px;
  font-size: 20px; // TODO: use themValues
  line-height: 32px;
  min-height: 52px;
  font-weight: 500;
  margin-bottom: 32px;

  .sub {
    color: ${themeValues.ghostColor};
    margin-left: 16px;
    font-weight: 500;
  }

  i {
    margin-right: 16px;
    color: ${themeValues.ghostColor};
  }
`;
PageHeader.displayName = "PageHeader";

interface IPageHeaderSectionProps {
  icon?: IconTypes;
  title?: string;
  children?: JSX.Element | string;
}

export function PageHeaderSection({ icon, title, children }: IPageHeaderSectionProps): JSX.Element {
  return <>
    {icon ? <i className={icon} /> : null} {children || title}
  </>;
}

export const PageContent = styled.div`
  font-size: ${themeValues.fontSize.large};
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  display: flex;

  h3 {
    font-weight: 500;
    margin: 1rem 0;
  }
`;

PageContent.displayName = "PageContent";

const StyledCTA = styled.div`
  margin-left: auto;
`;
StyledCTA.displayName = "StyledCTA";

const StyledPageContentHeader = styled.div`
  &.flex {
    display: flex;
    align-items: center;
    width: 100%;
  }

  ${StyledLearnMore} {
    margin-left: 10px;
  }
`;
StyledPageContentHeader.displayName = "StyledPageContentHeader";

interface IPageContentHeader {
  title?: string;
  children?: JSX.Element | string;
  learnMore?: string;
  cta?: JSX.Element;
}

export function PageContentHeader({ children, title, learnMore, cta }: IPageContentHeader): JSX.Element {
  const flex = !!(learnMore || cta);

  return <StyledPageContentHeader
    className={cn({
      "flex": flex
    })}>
    <span>{children || title}</span>
    {learnMore ? <LearnMore href={learnMore} /> : null}
    {cta ? <StyledCTA>{cta}</StyledCTA> : null}
  </StyledPageContentHeader>;
}

